import React from 'react';

const ProfileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 25 25">
    <path fill="#F7FAFC" d="M12.5 1C9.107 1 6.346 3.76 6.346 7.154c0 1.836.814 3.542 2.189 4.702l.21.17.26.2-.31.108C4.152 13.922 1 18.234 1 23.192c0 .412.308.752.706.802l.102.006h21.384c.446 0 .808-.362.808-.808 0-4.854-3.023-9.09-7.413-10.755l-.282-.103-.31-.108.26-.2c1.501-1.16 2.399-2.944 2.399-4.872C18.654 3.76 15.894 1 12.5 1zm0 12.308c4.985 0 9.171 3.725 9.803 8.608l.03.273.02.195H2.647l.02-.195c.508-5.016 4.757-8.881 9.834-8.881zm0-10.692c2.503 0 4.538 2.035 4.538 4.538 0 2.502-2.035 4.538-4.538 4.538S7.962 9.656 7.962 7.154c0-2.503 2.035-4.538 4.538-4.538z"/>
  </svg>
);

export default ProfileIcon;
